import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";

export default Vue.use(VueTelInputVuetify, {
  vuetify,
});
